import * as types from './actionTypes';
import bidApi from '../api/bidApi';

export const getBidsSuccess = bids => ({
  bids,
  type: types.GET_BIDS_SUCCESS
});

export const getBids = () =>
  dispatch =>
    bidApi.get().then((response) => {
      dispatch(getBidsSuccess(response.bids));
    });



// WEBPACK FOOTER //
// ./src/actions/bidActions.js